module.exports = __webpack_public_path__ + "resources/img/img_cheating_detection_m.ef2991ef7e881ad8b07f447da5e0afdf.png";